var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgColorGridGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AEL---T1---Landing---Bill-status-open",
    transform: "translate(-1227.000000, -389.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button---Sign-Up-for-MyTracker",
    transform: "translate(948.000000, 380.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Comparison-Icon",
    transform: "translate(279.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-71",
    fill: "#98DA41",
    transform: "translate(16.500000, 4.500000) scale(-1, 1) translate(-16.500000, -4.500000) ",
    x: 12,
    y: 0,
    width: 9,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-82",
    fill: "#98DA41",
    transform: "translate(4.500000, 4.500000) scale(-1, 1) translate(-4.500000, -4.500000) ",
    x: 0,
    y: 0,
    width: 9,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-75",
    fill: "#98DA41",
    transform: "translate(28.500000, 4.500000) scale(-1, 1) translate(-28.500000, -4.500000) ",
    x: 24,
    y: 0,
    width: 9,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-79",
    fill: "#FFFFFF",
    transform: "translate(40.500000, 4.500000) scale(-1, 1) translate(-40.500000, -4.500000) ",
    x: 36,
    y: 0,
    width: 9,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-72",
    fill: "#98DA41",
    transform: "translate(16.500000, 16.500000) scale(-1, 1) translate(-16.500000, -16.500000) ",
    x: 12,
    y: 12,
    width: 9,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-78",
    fill: "#FFFFFF",
    transform: "translate(4.500000, 16.500000) scale(-1, 1) translate(-4.500000, -16.500000) ",
    x: 0,
    y: 12,
    width: 9,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-76",
    fill: "#FFFFFF",
    transform: "translate(28.500000, 16.500000) scale(-1, 1) translate(-28.500000, -16.500000) ",
    x: 24,
    y: 12,
    width: 9,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-80",
    fill: "#98DA41",
    transform: "translate(40.500000, 16.500000) scale(-1, 1) translate(-40.500000, -16.500000) ",
    x: 36,
    y: 12,
    width: 9,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-73",
    fill: "#FFFFFF",
    transform: "translate(16.500000, 28.500000) scale(-1, 1) translate(-16.500000, -28.500000) ",
    x: 12,
    y: 24,
    width: 9,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-83",
    fill: "#98DA41",
    transform: "translate(16.500000, 40.500000) scale(-1, 1) translate(-16.500000, -40.500000) ",
    x: 12,
    y: 36,
    width: 9,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-74",
    fill: "#98DA41",
    transform: "translate(4.500000, 28.500000) scale(-1, 1) translate(-4.500000, -28.500000) ",
    x: 0,
    y: 24,
    width: 9,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-77",
    fill: "#98DA41",
    transform: "translate(28.500000, 28.500000) scale(-1, 1) translate(-28.500000, -28.500000) ",
    x: 24,
    y: 24,
    width: 9,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-84",
    fill: "#98DA41",
    transform: "translate(28.500000, 40.500000) scale(-1, 1) translate(-28.500000, -40.500000) ",
    x: 24,
    y: 36,
    width: 9,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-81",
    fill: "#98DA41",
    transform: "translate(40.500000, 28.500000) scale(-1, 1) translate(-40.500000, -28.500000) ",
    x: 36,
    y: 24,
    width: 9,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-85",
    fill: "#98DA41",
    transform: "translate(40.500000, 40.500000) scale(-1, 1) translate(-40.500000, -40.500000) ",
    x: 36,
    y: 36,
    width: 9,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-70",
    fill: "#98DA41",
    transform: "translate(4.500000, 40.500000) scale(-1, 1) translate(-4.500000, -40.500000) ",
    x: 0,
    y: 36,
    width: 9,
    height: 9
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorGridGreen);
export default __webpack_public_path__ + "static/media/color-grid-green.e6e6e44c5b15b9b36e4eab645c38fd64.svg";
export { ForwardRef as ReactComponent };